<aside>
    <div class="flex justify-center items-center ">
        <!-- <a [routerLink]="['/']" class="brand text-center "> </a> -->
            <!-- <h1 class="flex items-center font-bold text-slate-300">
                <span class="text-2xl mr-2 bg-green-600 w-8 h-8 rounded-md">N</span>
                <span class="text-3xl tracking-widest">ngWind</span>
            </h1> -->
           
             <img
      src="/assets/images/logo/oneci_logo.svg"
      alt="Orange background"
      class=" w-20 h-20  align-item object-contain text-center"
    /> 
    
        
    </div>
    <ul class="menu-links">
        <li>
            <a class="menu-item" [routerLink]="commonServices.prepareRoute(appRoutes.Admin, adminRoutes.Seance)"
                routerLinkActive="active" ariaCurrentWhenActive="page">
                <i class="bi bi-calendar-check"></i>
                <span>Gestion des réunions</span>
            </a>
        </li> 
       <li>
            <a [routerLink]="commonServices.prepareRoute(appRoutes.Admin, adminRoutes.Settings, settingRoutes.Users)"
                routerLinkActive="active" class="menu-item" ariaCurrentWhenActive="page">
                <i class="bi bi-people fs-4" ></i>
                <span>Gestion des utilisateurs</span>
            </a>
        </li> 
        
        <!-- <li>
            <a href="javascript:void(0)" class="menu-item sub-menu" aria-expanded="false"
                (click)="subMenuToggleHandler($event)">
                <i class="bi bi-diagram-3"></i>
                <span>UI Elements</span>
            </a>
            <ul class="sub-menu-item">
                <li>
                    <a class="menu-item"
                        [routerLink]="commonServices.prepareRoute(appRoutes.Admin, adminRoutes.Elements, elementRoutes.Alert)"
                        routerLinkActive="active" ariaCurrentWhenActive="page">
                        <span>Alert</span>
                    </a>
                </li>
                <li>
                    <a class="menu-item"
                        [routerLink]="commonServices.prepareRoute(appRoutes.Admin, adminRoutes.Elements, elementRoutes.Tabs)"
                        routerLinkActive="active" ariaCurrentWhenActive="page">
                        <span>Tabs</span>
                    </a>
                </li>
                <li>
                    <a class="menu-item"
                        [routerLink]="commonServices.prepareRoute(appRoutes.Admin, adminRoutes.Elements, elementRoutes.Modal)"
                        routerLinkActive="active" ariaCurrentWhenActive="page">
                        <span>Modal</span>
                    </a>
                </li>
                <li>
                    <a class="menu-item"
                        [routerLink]="commonServices.prepareRoute(appRoutes.Admin, adminRoutes.Elements, elementRoutes.Buttons)"
                        routerLinkActive="active" ariaCurrentWhenActive="page">
                        <span>Buttons</span>
                    </a>
                </li>
                <li>
                    <a class="menu-item"
                        [routerLink]="commonServices.prepareRoute(appRoutes.Admin, adminRoutes.Elements, elementRoutes.DataTable)"
                        routerLinkActive="active" ariaCurrentWhenActive="page">
                        <span>Data Table</span>
                    </a>
                </li>
                <li>
                    <a class="menu-item"
                        [routerLink]="commonServices.prepareRoute(appRoutes.Admin, adminRoutes.Elements, elementRoutes.Forms)"
                        routerLinkActive="active" ariaCurrentWhenActive="page">
                        <span>Forms</span>
                    </a>
                </li>
            </ul>
        </li> -->
            <a href="javascript:void(0)" class="menu-item sub-menu" aria-expanded="false"
                (click)="subMenuToggleHandler($event)">
                <i class="bi bi-gear"></i>
                <span>Paramètres</span>
            </a>
            <ul class="sub-menu-item">
                
                <li>
                    <a class="menu-item"
                        [routerLink]="commonServices.prepareRoute(appRoutes.Admin, ParametresRoutes.Direction)"
                        routerLinkActive="active" ariaCurrentWhenActive="page">
                        <span>Directions</span>
                    </a>
                </li>
                
            </ul>
        <!-- <li>
            <a href="#" class="menu-item">
                <i class="bi bi-box-arrow-right"></i>
                <span>Logout</span>
            </a>
        </li> -->
    </ul>
</aside>

<div class="collapsible-btn-container">
    <button id="sidebar-collapse-btn" sidebarCollapse>
        <div class="w-6 h-16 flex justify-center items-center">
            <div class="collapsible-icons">
                <div class="collapsible-top-icon"></div>
                <div class="collapsible-bottom-icon"></div>
            </div>
        </div>
    </button>
</div>